import {
	Component, Input, Output, OnChanges, SimpleChanges,
	SimpleChange, EventEmitter, OnInit
} from '@angular/core';


@Component({
	selector: 'google-admin-dialog',
	templateUrl: './google-admin-dialog.component.html',
	styleUrls: ['./google-admin-dialog.component.scss']
})
export class GoogleAdminDialogComponent implements OnChanges {

	@Input()
	public display: boolean = false;

	@Input()
	public messageType: string = "";

	@Output()
	public displayChange = new EventEmitter();

	@Output()
	public onOk = new EventEmitter();

	@Output()
	public onCancel = new EventEmitter();

	private buttonClicked: boolean = false;

	constructor() {
		return;
	}

	public ngOnInit(): void {
		return;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		
	}

	public onDialogHide(): void {
		if (this.buttonClicked) {
			this.buttonClicked = false;
		}
		else {
			this.doCancelActions();
		}
	}

	public cancel(): void {
		this.buttonClicked = true;
		this.doCancelActions();
	}

	private doCancelActions(): void {
		this.hideDialog();
		this.onCancel.emit();
	}

	public ok(): void {
		this.buttonClicked = true;
		this.hideDialog();
		this.onOk.emit();
	}

	public displayDialog() {
		this.display = true;
		this.displayChange.emit();
    }

    public hideDialog() {
		this.display = false;
		this.displayChange.emit();
	}
}
